import _styled from "styled-components";
import React from "react";
import { ToggledButton } from "../ToggledButton/ToggledButton";
import { formatDecimalNumber } from "./utils";
import { NumberInput } from "./NumberInput";
import { EnumInput } from "./EnumInput";

var Row = _styled.div.withConfig({
  displayName: "RegisterControl__Row",
  componentId: "q55av5-0"
})(["display:flex;align-items:center;margin-bottom:20px;padding:0 20px;justify-content:center;cursor:", ";"], function (p) {
  return p.active ? "pointer" : "default";
});

var Label = _styled.div.withConfig({
  displayName: "RegisterControl__Label",
  componentId: "q55av5-1"
})(["flex:1;font-size:20px;@media screen and (max-width:419px){font-size:18px;}"]);

var Value = _styled.div.withConfig({
  displayName: "RegisterControl__Value",
  componentId: "q55av5-2"
})(["margin-left:16px;font-size:20px;text-align:right;min-width:85px;@media screen and (max-width:419px){font-size:18px;}"]);

var TriggerButton = _styled.button.withConfig({
  displayName: "RegisterControl__TriggerButton",
  componentId: "q55av5-3"
})(["padding:0 20px;background:#4d9ade;color:white;border:0 none;border-radius:10px;height:50px;display:flex;align-items:center;justify-content:center;"]);

export function RegisterControl(_ref) {
  var regConfig = _ref.regConfig,
      value = _ref.value,
      setRegister = _ref.setRegister;
  var registerName = regConfig.id;
  var hasValue = typeof value !== "undefined";

  if (regConfig.type === "TRIGGER") {
    return /*#__PURE__*/React.createElement(Row, {
      key: registerName
    }, /*#__PURE__*/React.createElement(TriggerButton, {
      onClick: function onClick() {
        setRegister(registerName, 1);
      }
    }, regConfig.title));
  }

  if (regConfig.type === "BOOL") {
    return regConfig.writeable ? /*#__PURE__*/React.createElement(Row, {
      key: registerName,
      active: true
    }, /*#__PURE__*/React.createElement(Label, null, regConfig.title), /*#__PURE__*/React.createElement(ToggledButton, {
      on: value === 1,
      indeterminate: !hasValue,
      onChange: function onChange() {
        setRegister(registerName, 1 - value);
      }
    })) : /*#__PURE__*/React.createElement(Row, {
      key: registerName
    }, /*#__PURE__*/React.createElement(Label, null, regConfig.title), hasValue ? value ? "Актив." : "Неактив." : "--");
  }

  if (regConfig.type === "NUM") {
    var valueNode = /*#__PURE__*/React.createElement(Value, null, hasValue ? formatDecimalNumber(value, regConfig.decimals) : "--", regConfig.unit ? " ".concat(regConfig.unit) : undefined);
    return regConfig.writeable ? /*#__PURE__*/React.createElement(NumberInput, {
      key: registerName,
      value: value,
      title: regConfig.title,
      unit: regConfig.unit,
      incrementable: regConfig.incrementable,
      minValue: regConfig.minValue,
      maxValue: regConfig.maxValue,
      decimals: regConfig.decimals,
      onChange: function onChange(value) {
        return setRegister(registerName, value);
      }
    }, function (_ref2) {
      var onClick = _ref2.onClick;
      return /*#__PURE__*/React.createElement(Row, {
        onClick: onClick,
        active: true
      }, /*#__PURE__*/React.createElement(Label, null, regConfig.title), valueNode);
    }) : /*#__PURE__*/React.createElement(Row, {
      key: registerName
    }, /*#__PURE__*/React.createElement(Label, null, regConfig.title), valueNode);
  }

  if (regConfig.type === "ENUM") {
    var _valueNode = /*#__PURE__*/React.createElement(Value, null, hasValue ? regConfig["enum"][value] : "--", regConfig.unit ? " ".concat(regConfig.unit) : undefined);

    return regConfig.writeable ? /*#__PURE__*/React.createElement(EnumInput, {
      key: registerName,
      value: value,
      title: regConfig.title,
      valuesEnum: regConfig["enum"],
      onChange: function onChange(value) {
        return setRegister(registerName, +value);
      }
    }, function (_ref3) {
      var onClick = _ref3.onClick;
      return /*#__PURE__*/React.createElement(Row, {
        onClick: onClick,
        active: true
      }, /*#__PURE__*/React.createElement(Label, null, regConfig.title), _valueNode);
    }) : /*#__PURE__*/React.createElement(Row, {
      key: registerName
    }, /*#__PURE__*/React.createElement(Label, null, regConfig.title), _valueNode);
  }

  return null;
}